import { LoadingSpinner } from "@newsela/angelou";
import PropTypes from "prop-types";

import useClassroomRosterSyncGetList from "@/classrooms/useClassroomRosterSyncGetList";
import getUserProperties from "@/users/getUserProperties";
import formatDate from "@/utils/formatDate";
import getAuthProviderName from "@/utils/getAuthProviderName";
import { titleCss, linkCss } from "./AdditionalInformation.style";

const propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    auth_type: PropTypes.string.isRequired,
    last_login: PropTypes.string.isRequired,
  }).isRequired,
};

const AdditionalInformation = ({ user }) => {
  const userProperties = getUserProperties(user);
  const canSyncClassrooms = userProperties.hasFeature("can_sync_classrooms");
  const { data: rosterSyncList = [], loading: isLoading } =
    useClassroomRosterSyncGetList({ skip: !canSyncClassrooms });
  const rosterSync = rosterSyncList.find(
    (rosterSync) => rosterSync.provider === user.auth_type,
  );

  const PreferencesPortalButton = (
    <a
      href={`https://go.newsela.com/Subscription-Settings-Account-Page.html?email=${user.email}`}
      target="_blank"
      rel="noreferrer"
      css={linkCss}
    >
      communication preferences portal.
    </a>
  );

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <h3 css={titleCss}>Communication</h3>
      <span>
        To update email preferences, go to the {PreferencesPortalButton}
      </span>
      {rosterSync?.time_completed && (
        <>
          <h3 css={titleCss}>Last sync</h3>
          <span>
            {`Sync from ${getAuthProviderName(rosterSync.provider)}
            on ${formatDate(new Date(rosterSync.time_completed), "mm/dd/yyyy")}`}
          </span>
        </>
      )}
    </>
  );
};

AdditionalInformation.propTypes = propTypes;

export default AdditionalInformation;
